export default "__VITE_ASSET__BMh44wDL__"